import styled from 'styled-components';
import { ErrorMessage } from '../../ErrorMessage/index.js';

var LongInstruction = styled(ErrorMessage)`
  text-align: left;
`;

export { LongInstruction as default };
